/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const UserVipstatusBasicAccountColorIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={size} height={size} {...props}><path fill="#0A84FF" fillRule="evenodd" d="M18.685 19.097A9.72 9.72 0 0 0 21.75 12 9.75 9.75 0 0 0 12 2.25c-5.385 0-9.75 4.365-9.75 9.75a9.72 9.72 0 0 0 3.065 7.097A9.72 9.72 0 0 0 12 21.75a9.72 9.72 0 0 0 6.685-2.653m-12.54-1.285A7.49 7.49 0 0 1 12 15a7.49 7.49 0 0 1 5.855 2.812A8.22 8.22 0 0 1 12 20.25a8.22 8.22 0 0 1-5.855-2.438M15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0" clipRule="evenodd" /></svg>;
};
export default UserVipstatusBasicAccountColorIcon;